<template>
  <div>
    <div class="bar"></div>
    <div :style="style" class="progress"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: ['percent'],
  computed: {
    style() {
      return 'width: ' + (this.percent ? this.percent : 0) + '%';
    },
  },
};
</script>

<style scoped>
.bar {
  border-bottom: 1px solid lightgray;
  margin-bottom: -1px;
}
.progress {
  border-bottom: 1px solid black;
}
</style>
